/** @jsx jsx */
import { jsx, css } from '@emotion/core' // eslint-disable-line
import React, { Component } from 'react' // eslint-disable-line
import { observer } from 'mobx-react'
import * as dayjs from 'dayjs'
import { Table, Icon, Input, Button } from 'antd'
import { GeneralStyles } from '../../../styles/general'

import { instanceStore } from '../../../store/list/InstanceModel'
import BusinessStatus from '../../../business/status'
import StatusTag from '../../../components/StatusTag'
import InstanceViewer from '../../../components/business/InstanceViewer'
import MachineViewer from '../../../components/business/MachineViewer'
import UserViewer from '../../../components/business/UserViewer'

import { buildListPage, LIST_PAGE_TYPES } from '../../list_builder'

import InstanceListAction from './InstanceListAction'

interface IInstanceListProps { }

interface IInstanceListState {
  searchLoading: boolean
}

interface InstanceList {
  props: IInstanceListProps
  state: IInstanceListState
}

const INSTANCE_STATE = BusinessStatus.instance

const pageColumns = [
  {
    title: '序号',
    dataIndex: 'id',
    key: 'id',
  },
  {
    title: '实例Id',
    dataIndex: 'instance_id',
    key: 'instance_id',
    render: (text: any) => <InstanceViewer instance_id={text} />,
  },
  {
    title: '机器Id',
    dataIndex: 'machine_id',
    key: 'machine_id',
    render: (text: any) => <MachineViewer machine_id={text} />,
  },
  {
    title: '用户',
    dataIndex: 'uid',
    key: 'uid',
    render: (text: any) => <UserViewer uid={text} />,
  },
  {
    title: '总时长',
    dataIndex: 'hour',
    key: 'hour',
  },
  {
    title: 'GPU',
    dataIndex: 'unit',
    key: 'unit',
  },
  {
    title: '创建时间',
    dataIndex: 'create_time',
    key: 'create_time',
    render: (text: any) => (
      <span>{dayjs(text).format('YYYY年MM月DD日 HH:mm:ss')}</span>
    ),
  },
  {
    title: '状态',
    key: 'status',
    dataIndex: 'status',
    render: (status: any, item: any) => {
      return (
        <span>
          <StatusTag item={item} status={status} config={INSTANCE_STATE} />
        </span>
      )
    },
  },
  {
    title: '主机状态',
    key: 'vm_status',
    dataIndex: 'vm_status',
    render: (status: any, item: any) => {
      return (
        <span>
          <StatusTag item={item} status={item.vm_status} config={BusinessStatus.instance_vm} />
        </span>
      )
    },
  },
  {
    title: '操作',
    key: 'action',
    render: (text: any, record: any) => (
      <InstanceListAction text={text} record={record} />
    ),
  },
]

@observer
class InstanceList extends Component {
  constructor(props: IInstanceListProps) {
    super(props)

    this.state = {
      searchLoading: false,
    }
  }

  componentDidMount() {
    instanceStore.loadPageList()
  }

  reloadList = () => {
    instanceStore.reloadCurrentPage()
  }

  handleTableChange = (pagination: any) => {
    if (pagination['current'] === instanceStore.listResponse.current) {
      return
    }

    instanceStore.changePage(pagination['current'])
  }

  searchInstanceId = (instanceId: any) => {
    this.setState((preState, props) => ({
      searchLoading: true,
    }))
    instanceStore
      .loadPageList({
        instance_id: instanceId,
      })
      .then(() => {
        this.setState((preState, props) => ({
          searchLoading: false,
        }))
      })
  }

  render() {
    const listResponse = instanceStore.listResponse
    const pageList = listResponse.list.map((item: any) => {
      return {
        key: item['machine_id'],
        ...item,
      }
    })
    const loadState = instanceStore.listError

    return (
      <div className="general-page" css={GeneralStyles['general-page']}>
        <div css={GeneralStyles['page-head']}>
          <div className="head-title">
            <span className="title-text"><Icon type="cloud-server" /> 实例列表</span>
          </div>
        </div>
        <div css={GeneralStyles['page-content']}>
          <div css={GeneralStyles['content-pane']} className="content-pane">
            <div css={GeneralStyles['simple-pane-inner']}>
              <div className="simple-line-item">
                <Button icon="reload" onClick={this.reloadList} />
              </div>

              <div className="simple-line-item">
                <Input.Search
                  placeholder="输入实例ID"
                  loading={this.state.searchLoading}
                  onSearch={this.searchInstanceId}
                />
              </div>
            </div>
          </div>

          <div css={GeneralStyles['content-pane']} className="content-pane">
            <Table
              columns={pageColumns}
              rowKey={(record: any) => record.id}
              dataSource={pageList}
              pagination={{
                current: listResponse.current,
                total: listResponse.total,
                pageSize: listResponse.size,
              }}
              loading={loadState.state === 'loading'}
              onChange={this.handleTableChange}
            />
          </div>
        </div>
      </div>
    )
  }
}

export default buildListPage(LIST_PAGE_TYPES.INSTANCE, InstanceList)